import { render } from "./DefaultButton.vue?vue&type=template&id=bfd2955a"
import script from "./DefaultButton.vue?vue&type=script&lang=js"
export * from "./DefaultButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DefaultButton.vue"]])

export default __exports__